import { INSTANCE_BASED_CLUSTER, PRODUCTION } from 'pages/provisioning/aws/document-db/constant';

export const formOrderObjFromCart = (data = null) => {
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        department: environmentDetails?.department || null,
        appRegion: environmentDetails?.applicationRegion || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        entityDetails: {
            businessCi: environmentDetails?.businessService || catalogConfig?.tags?.BusinessService || null,
        },
        ...(catalogConfig?.environmentDetails?.environment === PRODUCTION && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        vpcId: catalogConfig?.vpcId || null,
        clusterIdentifier: catalogConfig?.documentDbClusterIdentifier || null,
        databaseName: catalogConfig?.dbName || null,
        clusterType: catalogConfig?.clusterType || null,
        enableGlobalCluster: catalogConfig?.environment === PRODUCTION && catalogConfig?.enableGlobalCluster === true ? 'yes' : 'no',
        globalClusterIdentifier: catalogConfig?.globalClusterIdentifier || null,
        secondaryRegion: catalogConfig?.secondaryRegion || null,
        engineVersion: catalogConfig?.engineVersion || null,
        instanceClass: catalogConfig?.instanceClass || null,
        numberOfInstances: catalogConfig?.instanceCount || null,
        expDBSize: catalogConfig?.initialStorageSize || null,
        minCapacityDcus: catalogConfig?.minCapacityDcus || null,
        maxCapacityDcus: catalogConfig?.maxCapacityDcus || null,
        shardCount: catalogConfig?.shardCount || null,
        instancesPerShard: catalogConfig?.instancesPerShard || null,
        vCPUsPerShard: catalogConfig?.vCpusPerShard || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        appRegion: environmentDetails?.applicationRegion || null,
        environment: catalogConfig?.environment || null,
        department: environmentDetails?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        entityDetails: {
            businessCi: environmentDetails?.businessService || catalogConfig?.tags?.BusinessService || null,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        vpcId: catalogConfig?.vpcId || null,
        clusterIdentifier: catalogConfig?.documentDbClusterIdentifier || null,
        databaseName: catalogConfig?.dbName || null,
        clusterType: catalogConfig?.clusterType || null,
        enableGlobalCluster: catalogConfig?.environment === PRODUCTION && catalogConfig?.enableGlobalCluster === true ? 'yes' : 'no',
        globalClusterIdentifier: catalogConfig?.globalClusterIdentifier || null,
        secondaryRegion: catalogConfig?.secondaryRegion || null,
        engineVersion: catalogConfig?.engineVersion || null,
        instanceClass: catalogConfig?.instanceClass || null,
        numberOfInstances: catalogConfig?.instanceCount || null,
        expDBSize: catalogConfig?.initialStorageSize || null,
        minCapacityDcus: catalogConfig?.minCapacityDcus || null,
        maxCapacityDcus: catalogConfig?.maxCapacityDcus || null,
        shardCount: catalogConfig?.shardCount || null,
        instancesPerShard: catalogConfig?.instancesPerShard || null,
        vCPUsPerShard: catalogConfig?.vCpusPerShard || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    drPriority: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource Section
    awsAccount: null,
    vpcId: null,
    clusterIdentifier: null,
    databaseName: '',
    isManualDBName: false,
    clusterType: INSTANCE_BASED_CLUSTER,
    enableGlobalCluster: 'no',
    engineVersion: null,
    instanceClass: null,
    numberOfInstances: null,
    expDBSize: null,
    minCapacityDcus: null,
    maxCapacityDcus: null,
    secondaryRegion: null,
    globalClusterIdentifier: null,
    shardCount: null,
    shardConfigurations: [],
    instancesPerShard: null,
    vCPUsPerShard: null,

    // Application Component Security Group Section
    componentName: null,
    componentNameDetails: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isDiskOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = [], catalogCode }) => {
    const payload = {
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            instanceType: order?.dbInstanceType,
            databaseEdition: order?.selectedEngineOption?.label,
            storageSize: order?.expDBSize,
            storageType: order?.storageTypeDetail?.storageType,
            haDeployment: order?.isMultiAzEnabled === 'yes',
            ...(order?.isEDRSEnabled === 'yes' && { edrsEnabled: true }),
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
            },
        },
    };
    return payload;
};
